// extracted by mini-css-extract-plugin
export default {"Container":"ComicBlock_Container__vCzLw"};